const booksList = [{
  "Id": 1,
  "ISBN": "9780241256480",
  "Name": "My Husband´s Wife",
  "Author": "",
  "Language": "English",
  "Description": `La sangre del padre, Finalista del Premio Planeta 2023, es una novela épica y colosal sobre el hombre que quiso salvar a los pueblos de la tiranía en aras de la libertad.

  Conquistó el imperio más poderoso del mundo,
  pero la guerra más violenta la libró contra sí mismo.
  
  Tras el asesinato de su padre, Alejandro asciende al trono de Macedonia. Acaba de heredar no solo el título, sino también el deber de salir victorioso en la misión que le reclama su pueblo: arrebatar a los persas las tierras que una vez fueron griegas y devolverles la libertad.
  Sin embargo, no puede detenerse ahí; la sangre de reyes, de héroes, de dioses que corre por sus venas lo obliga a llevar a cabo una empresa mucho más ambiciosa. Quiere conquistar Babilonia, Persépolis y todas las ciudades en su camino hacia el este, hasta vencer al último rey aqueménida, el temible Darío, y acabar con el Imperio persa para siempre.
  Sabe que es su destino. Solo él puede lograrlo, solo él puede conquistar el mundo; solo él es Alejandro Magno.`,
  "Category": "Ficción",
  "AuthorId": 1
}, {
  "Id": 2,
  "ISBN": "978-8408280187",
  "Name": "La sangre del padre",
  "Author": "",
  "Language": "Español",
  "Description": `Con cada compra, Amazon dona un crédito virtual a escuelas en una región de tu elección, sin coste adicional para ti. Iniciativa sujeta a Términos y Condiciones.: Registrate gratis en Un clic para el cole
  La sangre del padre, Finalista del Premio Planeta 2023, es una novela épica y colosal sobre el hombre que quiso salvar a los pueblos de la tiranía en aras de la libertad.
  
  Conquistó el imperio más poderoso del mundo,
  pero la guerra más violenta la libró contra sí mismo.
  
  Tras el asesinato de su padre, Alejandro asciende al trono de Macedonia. Acaba de heredar no solo el título, sino también el deber de salir victorioso en la misión que le reclama su pueblo: arrebatar a los persas las tierras que una vez fueron griegas y devolverles la libertad.
  Sin embargo, no puede detenerse ahí; la sangre de reyes, de héroes, de dioses que corre por sus venas lo obliga a llevar a cabo una empresa mucho más ambiciosa. Quiere conquistar Babilonia, Persépolis y todas las ciudades en su camino hacia el este, hasta vencer al último rey aqueménida, el temible Darío, y acabar con el Imperio persa para siempre.
  Sabe que es su destino. Solo él puede lograrlo, solo él puede conquistar el mundo; solo él es Alejandro Magno.`,
  "Category": "Ficción biográfica",
  "AuthorId": 1
}, {
  "Id": 3,
  "ISBN": "978-8401030130",
  "Name": "La armadura de la luz",
  "Author": "",
  "Language": "Spanish",
  "Description": `Vuelve el mejor Follett con la emocionante quinta entrega de la saga «Los pilares de la Tierra».
  
  El choque de progreso y tradición y una guerra que amenaza con engullir toda Europa en la más ambiciosa y épica novela del maestro de la ficción histórica.
  
  La revolución está en el aire
  1792. Un gobierno despótico está decidido a convertir Inglaterra en un poderoso imperio comercial. Y, desde el otro lado del mar, suenan tambores de guerra mientras Napoleón Bonaparte comienza su ascenso al poder y prepara un violento plan para convertirse en emperador del mundo.
  
  Kingsbridge se asoma al abismo
  Los nuevos avances industriales se imponen de manera implacable, sacudiendo las vidas de los trabajadores de las prósperas fábricas textiles de Kingsbridge. Las máquinas abren un mundo de oportunidades ligado, sin embargo, a la crueldad más despiadada.
  
  Una nueva tiranía surge en el horizonte
  Y a medida que el estallido de un conflicto parece cada vez más cerca, la historia de un pequeño grupo de personas -la decidida hilandera Sal Clitheroe, el idealista David Shoveller y Kit, el brillante hijo de Sal- se convertirá en el símbolo de la lucha de toda una generación que desea progresar y pelea por un futuro sin opresión...
  
  Sobra la saga «Los pilares de la Tierra» han dicho:
  «Sigo envidiando como el primer día la capacidad de Follett para entretener. Sus tramas funcionan siempre y te mantiene pegado a cada página».
  Juan Gómez Jurado, ABC
  
  «Fantástico desde todos los puntos de vista».
  El Mundo
  
  «Follett es un maestro».
  The Washington Post
  
  «Una obra que destaca como un triunfo del esfuerzo y la profesionalidad».
  The Guardian
  
  «No hay rincón sin sorpresa ni página tediosa».
  Qué leer
  
  «Sus libros crean adicción. No se leen. Se devoran».
  La Voz de Asturias`,
  "Category": "Acción y aventura",
  "AuthorId": 2
}, {
  "Id": 4,
  "ISBN": "978-8466676564",
  "Name": "Maldita Roma (Serie Julio César 2)",
  "Author": "",
  "Language": "Spanish",
  "Description": `LA LEYENDA CONTINÚA.

  Tras el monumental éxito de Roma soy yo, continúa la saga sobre Julio César, narrada como sólo Posteguillo podría hacerlo.
  
  ROMA LO EXIGE TODO.
  
  EN ROMA TODO ESTÁ EN VENTA.
  
  MALDITA SEA POR SIEMPRE ROMA.
  
  Mare Internum, año 75 a. C. Un barco mercante navega rumbo a la isla de Rodas. A bordo, Julio César acompañado sólo por su fiel Labieno. Obligado por sus enemigos a exiliarse de Roma, se dirige al encuentro con el maestro Apolonio para aprender oratoria y de este modo, a su regreso, iniciar una feroz pugna para ingresar en el Senado y enfrentarse allí al temido Cicerón.
  
  Así arranca la extraordinaria segunda entrega de la saga dedicada a Julio César por Santiago Posteguillo. En Maldita Roma encontraremos ya al mito en la plenitud de su talento político y militar, dispuesto a vencer cualquier obstáculo en su imparable conquista del poder.
  
  Este es un relato sin tregua en el que viviremos ataques piratas, el enfrentamiento con Espartaco en la rebelión de los esclavos, grandes batallas en las que sentiremos el olor de la sangre y el estruendo de los gladios. Comprenderemos los hábiles manejos de César para ascender en política y asistiremos, incluso, al nacimiento de la reina Cleopatra a orillas del Nilo.
  
  Una novelamagistral que nos habla sobre el auténtico precio del poder. Y es que Julio César está a punto de aprender que Roma lo exige todo, hasta su bien más preciado, lo único que él no está dispuesto a entregar. Pero Roma no negocia con nadie. Ni con César. Maldita Roma.
  
  «Posteguillo aporta ritmo y rigurosidad al mito de Julio César».
  El País
  
  «El gran escritor español de novela histórica aborda al más genial de los hombres».
  El Mundo`,
  "Category": "Historia antigua",
  "AuthorId": 3
}, {
  "Id": 5,
  "ISBN": "978-1519006110",
  "Name": "O Alquimista",
  "Author": "",
  "Language": "Portugues",
  "Description": `Con cada compra, Amazon dona un crédito virtual a escuelas en una región de tu elección, sin coste adicional para ti. Iniciativa sujeta a Términos y Condiciones.: Registrate gratis en Un clic para el cole “Quando você quer alguma coisa, todo o Universo conspira para que você realize seu desejo.” De tempos em tempos, surge um livro que muda para sempre a vida de seus leitores. O Alquimista é um deles. Com mais de 85 milhões de exemplares vendidos no mundo inteiro, o mais famoso título de Paulo Coelho já se estabeleceu como um clássico moderno, atemporal e universal. Mais de 25 anos após seu lançamento, segue fascinando públicos cada vez maiores, de diferentes gerações. Simples, sábia e inspiradora, esta história refaz os passos de um pastor da Andaluzia que viaja para o deserto egípcio em busca de um tesouro enterrado nas Pirâmides. O que começa como uma jornada para encontrar bens mate¬riais torna-se uma descoberta das riquezas que escondemos dentro de nós mesmos. As belas lições que Santiago aprende pelo caminho nos falam da sabedoria de ouvir o que diz nosso coração, ler os sinais com que deparamos ao longo da vida e, acima de tudo, seguir os nossos sonhos.`,
  "Category": "Ficción literaria",
  "AuthorId": 4
}, {
  "Id": 6,
  "ISBN": "B00CSKDG4C",
  "Name": "El Peregrino de Compostela",
  "Author": "",
  "Language": "Spanish",
  "Description": `En este apasionante relato, Paulo Coelho narra las peripecias de su peregrinaje por el Camino de Santiago. En compañía de su guía espiritual, el misterioso y enigmático Petrus, Paulo se enfrenta a una serie de pruebas y ejercicios, conoce a figuras que ponen en apuros su determinación y su fe, sortea peligros insidiosos y tentaciones amenazadoras, para encontrar la espada que le permitirá convertirse en Maestro RAM.

  El Camino, que Paulo Coelho recorrió en 1986, consiguió inspirar una novela de aventuras, que es, al mismo tiempo, una fascinante parábola sobre la necesidad de encontrar nuestro camino en la vida.`,
  "Category": "",
  "AuthorId": 4
}];

export default booksList;